module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NLo3nQ/tc-custom/9789948810087.jpg?1705539895649",
      "alt": "This image is the cover for the book أنا صُنعت من الظلام أنا كُلياً سوداء"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("أنا صُنعت من الظلام أنا كُلياً سوداء\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("أخبرني أبي يوماً بأنني ساكنة كـحلك الظلام ببداية الشهر الشتوي أمرُ باطمئنان، تعتلي سمائي نجومٌ براقة ورياحي باردة، وأخبرني أيضاً بأنها أحب اللّيالي له لأنها مليئة بالحنان. .Once Dad told me that I’m calm as the beginning of winter’s nights slowly comforting them and having a sparkling stars .He told me that these are the nights that he loves because of the warm of everyone’s feelings within")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      ايون\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("اسمها نورة.. يمكنك أن تدعوها \"أيون\". هي بشريَّةٌ أَحَبَّتْ كونها مُظلمة ومعتمة، وهذا ما جعلها جميلة. أتُريد أن تعلم ما الذي يجعلها أفضل؟ لأنَّها تقبَّلَتِ اختلافها. لذا تريد أن تخُطَّ بعض الكلمات بسوادها، وتُعيرَك إيَّاها. The author's name is Noura but she likes to be called iON. She is a human who loves being dark. That's what makes her beautiful. And do you know what makes it better? That she has accepted who she is. Now she wants to turn her gloom into words so you can borrow them. ****** فتاة آمنَت دائمًا أنَّه كَون الشَّخص مُظلِمًا لا يعني بأنَّه لا يمتلك الأحقيَّة في التميُّز، وذلك بحدِّ ذاته ما ميَّزَها. لذا بدأَت في الكتابة لإخبار الجميع أنَّ الاختلاف لا يعني النهاية، بل بداية تاريخٍ آخَر. ثقَّفَت نفسها، وأبرَزَت حروفها.. رسمَت وأنجزَت، وها هي تبدأ مسيرتها.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0